import { ISectionSettings } from 'legacy/lut/classes/models/partner360/IFormPartnerBasicInfo'

import Logger from 'core/utils/Logger'

export function parseSectionSettings(json: string | null): Partial<ISectionSettings> {
  try {
    return json ? JSON.parse(json) : {}
  } catch (e) {
    Logger.error('Error on parse section settings')
    return {}
  }
}
